import { create } from "zustand";

type FiltersNavigationState = {
  isSyncing: boolean;
  setSyncing: (value: boolean) => void;
};

export const useFiltersNavigationStore = create<FiltersNavigationState>(
  (set) => ({
    isSyncing: false,
    setSyncing: (value) => set({ isSyncing: value }),
  })
);
